import React from 'react'
import Home from 'view/page/home'
import FootballDevelopment from 'view/page/football-development'
import FootballAdministration from 'view/page/football-administration'
import FootballOperations from 'view/page/football-operations'
// Football Development Routes
import GovernanceAndQA from 'view/page/football-development/pages/governance-and-qa'
import PerformancePathway from 'view/page/football-development/pages/performance-pathway'
import Productivity from 'view/page/football-development/pages/performance-pathway/pages/productivity'
import ProgressionRates from 'view/page/football-development/pages/performance-pathway/pages/progression-rates'
import SuccessfulPlayerJourney from 'view/page/football-development/pages/performance-pathway/pages/successful-player-journey'
import Transition from 'view/page/football-development/pages/performance-pathway/pages/transition'
import PlayersEppp from 'view/page/football-development/pages/eppp'
import EPPPPlayerDevelopment from 'view/page/football-development/pages/eppp/pages/player-development'
import HighPotential from 'view/page/football-development/pages/high-potential'
import DutyOfCare from 'view/page/football-development/pages/duty-of-care'
import ECPPlayerDevelopment from 'view/page/football-development/pages/ecp'
import PlayersErdp from 'view/page/football-development/pages/erdp'
// Football Administration Routes
import Transfers from 'view/page/football-administration/pages/transfers'
import PlayerRegistrations from 'view/page/football-administration/pages/player-registrations'
// Football Operations Routes
import KPIS from 'view/page/football-operations/pages/kpis'
import PlayingTime from 'view/page/football-operations/pages/playing-time'
import Attendance from 'view/page/football-operations/pages/attendance'
import Officiating from 'view/page/football-operations/pages/officiating'
import ComingSoon from 'view/component/coming-soon'
import * as ROUTES from './routes'

export const navRoutes = [
  {
    component: <Home />,
    exact: false,
    href: ROUTES.HOME
  },
  {
    component: <FootballDevelopment />,
    exact: false,
    href: ROUTES.FOOTBALL_DEVELOPMENT
  },
  {
    component: <FootballAdministration />,
    exact: false,
    href: ROUTES.FOOTBALL_ADMINISTRATION
  },
  {
    component: <FootballOperations />,
    exact: false,
    href: ROUTES.FOOTBALL_OPERATIONS
  },
  {
    component: <PlayersEppp />,
    exact: false,
    href: ROUTES.PLAYERS_EPPP
  },
  {
    component: <EPPPPlayerDevelopment />,
    exact: false,
    href: ROUTES.EPPP_PLAYER_DEVELOPMENT
  },
  {
    component: <ECPPlayerDevelopment />,
    exact: false,
    href: ROUTES.COACHES_ECP
  },
  {
    component: <PlayersErdp />,
    exact: false,
    href: ROUTES.MATCH_OFFICIALS_ERDP
  },
  {
    component: <HighPotential />,
    exact: false,
    href: ROUTES.HIGH_POTENTIAL
  },
  {
    component: <PerformancePathway />,
    exact: false,
    href: ROUTES.PERFORMANCE_PATHWAY
  },
  {
    component: <SuccessfulPlayerJourney />,
    exact: false,
    href: ROUTES.SUCCESSFUL_PLAYER_JOURNEY
  },
  {
    component: <ProgressionRates />,
    exact: false,
    href: ROUTES.PROGRESSION_RATES
  },
  {
    component: <Transition />,
    exact: false,
    href: ROUTES.TRANSITION
  },
  {
    component: <Productivity />,
    exact: false,
    href: ROUTES.PRODUCTIVITY
  },
  {
    component: <DutyOfCare />,
    exact: false,
    href: ROUTES.DUTY_OF_CARE
  },
  {
    component: <GovernanceAndQA />,
    exact: false,
    href: ROUTES.GOVERNANCE_AND_QA
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.INNOVATION_AND_INSIGHTS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.EQUALITY_DIVERSITY_INCLUSION
  },
  {
    component: <KPIS />,
    exact: false,
    href: ROUTES.KPIS
  },
  {
    component: <PlayingTime />,
    exact: false,
    href: ROUTES.PLAYING_TIME
  },
  {
    component: <Attendance />,
    exact: false,
    href: ROUTES.ATTENDANCE
  },
  {
    component: <Officiating />,
    exact: false,
    href: ROUTES.OFFICIATING
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.SUBSTITUTIONS
  },
  {
    component: <Transfers />,
    exact: false,
    href: ROUTES.TRANSFERS
  },
  {
    component: <PlayerRegistrations />,
    exact: false,
    href: ROUTES.PLAYER_REGISTRATIONS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.STAFF_REGISTRATIONS
  }
]
